import {Row} from 'antd';
import classes from '../Pages.module.css';
import DataField from './DataField';

const AddressDetails = (props) => {

    const handleChange = (e,param,id) => {

        props.setData(data => {
            const newdata = [...data['employeeMaster']]
            newdata[0][param] = e.target.value
            return({
                ...data,
                employeeMaster: newdata
            })
        })
    }

    const handleSChange = (val,param) => {

        props.setData(data => {
            const newdata = [...data['employeeMaster']]
            newdata[0][param] = val
            return({
                ...data,
                employeeMaster: newdata
            })
        })
    }


    return(
        <div>
        <p></p>
        <p style={{ fontWeight: "bolder" }}>Permanent Address</p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField 
                editMode={props.editMode} 
                lg={24} 
                md={24} 
                handleChange={handleChange} 
                param="address" 
                name="Address" 
                value={props.data.address} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.CITY_CODE} 
                param="city_code" 
                type="Select" 
                name="City" 
                value={props.data.city_code} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.STATE_CODE} 
                param="state_code" 
                type="Select" 
                name="State" 
                value={props.data.state_code} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.COUNTRY_CODE} 
                param="country_code" 
                type="Select" 
                name="Country" 
                value={props.data.country_code} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleChange} 
                param="pincode" 
                name="PIN" 
                value={props.data.pincode} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                param="fax" 
                name="Fax" 
                value={props.data.fax} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                param="mobile" 
                name="Mobile" 
                value={props.data.mobile} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                param="phone" 
                name="Phone" 
                value={props.data.phone} 
            />
        </Row>
        <hr></hr>
        <p style={{ fontWeight: "bolder" }}>Present Address</p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField 
                editMode={props.editMode} 
                lg={24} 
                md={24} 
                handleChange={handleChange} 
                param="address_present" 
                name="Address" 
                value={props.data.address_present} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.CITY_CODE} 
                param="city_code_present" 
                type="Select" 
                name="City" 
                value={props.data.city_code_present} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.STATE_CODE} 
                param="state_code_present" 
                type="Select" 
                name="State" 
                value={props.data.state_code_present} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.COUNTRY_CODE} 
                param="country_code_present" 
                type="Select" 
                name="Country" 
                value={props.data.country_code_present} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                param="pincode_present" 
                name="PIN" 
                value={props.data.pincode_present} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                param="phone_present" 
                name="Phone" 
                value={props.data.phone_present} 
            />
        </Row>
        <hr></hr>
        <p style={{ fontWeight: "bolder" }}>Corresponding Address</p>
        <Row className={props.editMode ? classes['RowDEX'] : classes['RowD']}>
            <DataField 
                editMode={props.editMode} 
                lg={24} 
                md={24} 
                handleChange={handleChange} 
                param="address_corr" 
                name="Address" 
                value={props.data.address_corr} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.CITY_CODE} 
                param="city_code_corr" 
                type="Select" 
                name="City" 
                value={props.data.city_code_corr} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={12} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.STATE_CODE} 
                param="state_code_corr" 
                type="Select" 
                name="State" 
                value={props.data.state_code_corr} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleSChange} 
                options={props.ad.COUNTRY_CODE} 
                param="country_code_corr" 
                type="Select" 
                name="Country" 
                value={props.data.country_code_corr} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                param="pincode_corr" 
                name="PIN" 
                value={props.data.pincode_corr} 
            />
            <DataField 
                editMode={props.editMode} 
                lg={8} 
                md={24} 
                handleChange={handleChange} 
                param="phone_corr" 
                name="Phone" 
                value={props.data.phone_corr} 
            />
        </Row>
        <hr></hr>
    </div>
    
    );
}

export default AddressDetails